import { GOOGLE_ADS_CAMPAIGN_STATUS } from '../../../../../../../services/exports/Constants';

export default {
  buttons: {
    back: 'Retour',
  },
  metrics: {
    impressions: {
      label: 'Impressions',
      description:
        'Le nombre de fois où votre annonce a été affichée sur les résultats de recherche Google ou les sites partenaires.',
    },
    clicks: {
      label: 'Clics',
      description: 'Le nombre de fois où des personnes ont cliqué sur votre annonce.',
    },
    budget_spent: {
      label: 'Budget dépensé',
      description: 'Le montant total dépensé pour cette campagne.',
    },
    absolute_top_impression_percentage: {
      label: "% d'impressions absolues en tête",
      description:
        'Le pourcentage de fois où votre annonce est apparue tout en haut des résultats de recherche Google.',
    },
    phone_calls: {
      label: 'Appels',
      description: "Le nombre total d'appels téléphoniques reçus depuis votre annonce.",
    },
    phone_impressions: {
      label: 'Impressions téléphoniques',
      description: "Le nombre de fois où votre numéro de téléphone a été affiché dans l'annonce.",
    },
    phone_through_rate: {
      label: "Taux d'appel téléphonique",
      description:
        "Le pourcentage d'impressions téléphoniques ayant abouti à des appels (Appels ÷ Impressions téléphoniques).",
    },
    directions: {
      label: 'Itinéraires',
      description:
        "Le nombre de fois où des utilisateurs ont cliqué pour obtenir l'itinéraire vers votre établissement.",
    },
    daily_budget: {
      label: 'Budget quotidien',
      description: 'Le montant maximum défini à dépenser par jour pour cette campagne.',
    },
    status: {
      label: 'Statut',
      description: "L'état de fonctionnement actuel de votre campagne.",
    },
    ctr: {
      label: 'Taux de clics',
      description: "Le pourcentage de vues d'annonce ayant abouti à des clics (Clics ÷ Impressions).",
    },
    average_cpc: {
      label: 'Coût moyen par clic',
      description: 'Le montant moyen payé à chaque clic sur votre annonce (Coût total ÷ Clics totaux).',
    },
    conversions_from_interactions_rate: {
      label: 'Taux de conversion',
      description: "Le pourcentage d'interactions avec l'annonce ayant conduit à une conversion.",
    },
    start_date: {
      label: 'Date de début',
      description: 'La date de démarrage de la campagne.',
    },
    sales_from_google_ads: {
      label: 'Ventes via Google Ads',
      description: 'Le montant total généré via Google Ads.',
    },
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Non spécifié',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Activée',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'En pause',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Inconnu',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Supprimée',
  },
  error_messages: {
    loading_failed: 'Échec du chargement des détails de la campagne. Veuillez réessayer.',
  },
};
